import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/i18n/EmbedI18nProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/player.css");
